import { Texts, Title, Media, Button } from "../Object";
import { Space } from "../Layout";

const Banner = (props) => {

  return (
    <>
      <div className="l-row">
        <div className="c-grid__wrap--banner">
          <Button link="/partner/" type="banner">
            <Title slug="busi"></Title>
          </Button>
          <Button link="/company/" type="banner">
            <Title slug="company"></Title>
          </Button>
        </div>
      </div>
    </>
  );
};

export default Banner;
